// default options
const defaultOptions = {
  storageKey: 'iono-player-settings',
  storage: null,
  settings: {}
};

const Storage = {
  get (storage, key) {
    try {
      if (storage && typeof storage.getItem === 'function') {
        return storage.getItem(key);
      }
    } catch (e) {}
  },

  set (storage, key, value) {
    try {
      if (storage && typeof storage.setItem === 'function') {
        storage.setItem(key, value);
      }
    } catch (e) {}
  },

  clear (storage, key) {
    try {
      if (storage && typeof storage.removeItem === 'function') {
        storage.removeItem(key);
      }
    } catch (e) {}
  }
};

/**
 * Repository for player settings which can save settings to storage
 *
 * @todo update Settings to save ALL settings, implementers need to be updated to only set the keys they want stored
 *
 * Takes an options object to configure the repository. Options include:
 *  * storageKey - the key to persist settings data to in storage
 *  * storage - the storage mechanism to use, should follow the localStorage api
 *  * settings - the default settings to use
 */
export default class Settings {
  /**
   * Constructor.
   *
   * @param {object} options The options used to configure the settings repository
   */
  constructor (options = {}) {
    options = Object.assign({}, defaultOptions, options);
    options.settings = Object.assign({}, defaultOptions.settings, options.settings);

    this.storageKey = options.storageKey;
    this.storage = options.storage;
    this.settings = options.settings;

    this.stored = JSON.parse(Storage.get(this.storage, this.storageKey) || '{}');
  }

  /**
   * Get the value of a setting
   *
   * @param {string} key The setting to retrieve
   *
   * @return {mixed}
   */
  get (key) {
    return typeof this.stored[key] !== 'undefined' ? this.stored[key] : this.settings[key];
  }

  /**
   * Set the value of a setting
   *
   * @param {string} key   The setting to be set
   * @param {mixed}  value The new value of the setting
   */
  set (key, value) {
    this.stored[key] = value;
  }

  /**
   * Unset the value of a setting
   *
   * @param {string} key The setting to be unset
   */
  unset (key) {
    delete this.stored[key];
  }

  /**
   * Clear all settings
   */
  clear () {
    this.stored = {};
    Storage.clear(this.storage, this.storageKey);
  }

  /**
   * Save the settings to storage
   */
  save () {
    Storage.set(this.storage, this.storageKey, JSON.stringify(this.stored));
  }
}
